import { render, staticRenderFns } from "./AdminStudyItemTable.vue?vue&type=template&id=655d62fe&"
import script from "./AdminStudyItemTable.vue?vue&type=script&lang=js&"
export * from "./AdminStudyItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports